export const HOME_PATH = "/";
export const ICON_LIST_PATH = "/icons";
export const LICENSE_PATH = "/license";
export const EXAMPLES_PATH = "/examples";
export const ABOUT_PATH = "/about";
export const COMPOSER_PATH = "/composer";
export const STUDIO_PATH = "/studio";
export const NEW_ICON_CATEGORIES = Object.freeze(['duotone']);
// Icons people see: a duotone icon counts once, though its two layers are two glyphs
export const ICON_COUNT = 2267;
export const ICON_COUNT_TEXT = ICON_COUNT.toLocaleString("en-US");
// Every glyph in the font; the full icon list has loaded once there are this many
export const GLYPH_COUNT = 2429;

// The API is served by the same server as the pages, so requests stay on whatever host
// the site runs on (local, staging or icofont.com)
export const API_URL = "";

// Names from the site UI icon set (src/shared/Layouts/Icon/uiIcons.js)
export const CATEGORY_ICONS = Object.freeze({
  default: "exclamation",
  abstract: "circuit",
  animal: "squirrel",
  brand: "brand-apple",
  business: "briefcase-2",
  chart: "chart-pie",
  construction: "worker",
  currency: "dollar",
  device: "apple-watch",
  directional: "circled-up",
  duotone: "duotone:user-notes",
  education: "book",
  emoticon: "heart-eyes",
  "file-type": "file-pdf",
  fitness: "dumbbells",
  food: "tea",
  kids: "candy",
  law: "law",
  mathmetical: "calculator-alt-2",
  medical: "first-aid",
  "mobile-ui": "ui-bluetooth",
  multimedia: "video",
  payment: "mastercard",
  person: "user-alt-4",
  search: "search-2",
  social: "twitter",
  sport: "football",
  "text-editor": "color-picker",
  transport: "airplane-alt",
  travel: "beach",
  weather: "full-sunny",
  "web-application": "at",
});

export const ALLOWED_DOMAINS = ['www.icofont.com', 'icofont.com', 'https://icofont.com', 'https://www.icofont.com'];